/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insights_Kind_Join_BurstInputs */



/**
* | output |
* | --- |
* | "Join spikes" |
*
* @param {Insights_Kind_Join_BurstInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const insights_kind_join_burst = /** @type {((inputs?: Insights_Kind_Join_BurstInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insights_Kind_Join_BurstInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всплески входов")
	return /** @type {LocalizedString} */ ("Join spikes")
});